import { ToolCallData } from "../stores";

import { ToolCallWidget } from "./ToolCallWidget";
import { useFloatingWidgetChartLayout } from "./FloatingWidget/FloatingWidgetChartLayoutContext";

import AnalyticsGraphChartsGrid from "@/components/RequestsAnalytics/AnalyticsGraphChartsGrid";
import { CHART_CARD_HEIGHT_CLASS } from "@/components/RequestsAnalytics/constants";
import { parseAnalyticsGraphFromToolCallOutput } from "@/components/RequestsAnalytics/utils/parseAnalyticsGraphArtifact";
import { cn } from "@/lib/utils";
import type { AnalyticsGraphToolChartData } from "@/queries/analytics-custom-charts-types";

interface CreateAnalyticsGraphToolContentProps {
  toolCall: ToolCallData;
  hideNavigation?: boolean;
  useNavigationRow?: boolean;
  compactCharts?: boolean;
  onChartDataChange?: (chartData: AnalyticsGraphToolChartData) => void;
}

const ANALYTICS_GRAPH_BREAKOUT_CLASS =
  "ml-[calc((100%_-_min(64rem,100cqw))/2)] w-[min(64rem,100cqw)]";

export const CreateAnalyticsGraphToolContent = ({
  toolCall,
  hideNavigation = false,
  useNavigationRow = false,
  compactCharts = false,
  onChartDataChange,
}: CreateAnalyticsGraphToolContentProps) => {
  const graphArtifact = parseAnalyticsGraphFromToolCallOutput(toolCall.output);
  const { isChatFullscreen, shouldRenderCharts } = useFloatingWidgetChartLayout();

  return (
    <div className="my-0.5 w-full max-w-full">
      {!graphArtifact && (
        <ToolCallWidget
          toolCall={toolCall}
          hideNavigation={hideNavigation}
          useNavigationRow={useNavigationRow}
        />
      )}
      {graphArtifact ? (
        <div className={cn("w-full", ANALYTICS_GRAPH_BREAKOUT_CLASS)}>
          {shouldRenderCharts ? (
            <AnalyticsGraphChartsGrid
              key={`${isChatFullscreen}:${graphArtifact.title}`}
              artifact={graphArtifact}
              compact={compactCharts}
              onChartDataChange={onChartDataChange}
            />
          ) : (
            <div
              aria-hidden
              className={cn(
                "w-full rounded-lg border border-gray-200 bg-white",
                CHART_CARD_HEIGHT_CLASS,
              )}
            />
          )}
        </div>
      ) : null}
    </div>
  );
};
